type Props = {
	eyebrow?: string;
	title: string;
	subhead?: string;
};

export default function InsuranceLicenseHeader(props: Props) {
	const { eyebrow = 'Documents', title, subhead } = props;

	return (
		<div className="insurance-license-header">
			<div>
				<p className="eyebrow">{eyebrow}</p>
				<h2>{title}</h2>
				{subhead ? <p className="subhead">{subhead}</p> : null}
			</div>
		</div>
	);
}
